(function () {
    "use strict";

    angular.module("virtualFairs")
        .controller("VirtualFairSeminarsFormController", VirtualFairSeminarsFormController);
    

        VirtualFairSeminarsFormController.$inject = ['$uibModal', '$filter', '$scope','SellerService' ,'ExpoService', 'VirtualFairService', 'seminars', '$state','toastr','$stateParams', 'TimezonesService'];


    function VirtualFairSeminarsFormController( $uibModal, $filter, $scope, SellerService, ExpoService, VirtualFairService, seminars, $state, toastr, $stateParams, TimezonesService) {
        
        var vm = this;

        vm.seminars              = '';
        vm.queryFlag             = false;
        vm.exhibitorName         = '';
        vm.virtual_fair          = '';
        vm.platform_theme        = '';
        vm.goToList              = goToList;
        vm.seminars              = [{
            id:             '', 
            order:          '',
            title:          '',
            description:    '',
            institution:    '',
            show_date:      false,
            is_live:        false,
            order:          '',
            logo_url:       '',
            language:       '',
            presenters:     '',            
            virtual_fair_id: '',
            platform_theme: '',
            sessions:       [{
                button_label: '',
                url: '',
                order: '',
                start_datetime_utc: '',
                end_datetime_utc: '',
            }],
            cover: '',
        }];
        vm.delete_seminars       = [];
        vm.index                 = 0;
        vm.expo                  = '';

        vm.seller                = '';
        vm.sellerSelected        = '';
        vm.active                = [{name:'All',value:'All'}, {name:'Yes', value:1}, {name:'No', value:0}];
        vm.activeSelected        = {name:'Yes', value:1};
        vm.selectExpo            = selectExpo;
        vm.getSellers            = getSellers;
        vm.mountSeminar          = mountSeminar;
        vm.store                 = store;
        vm.save                  = save;
        vm.addSession            = addSession;
        vm.addSeminar            = addSeminar;
        vm.removeSession         = removeSession;
        vm.uploadHandler         = uploadHandler;
        vm.imageCrop             = imageCrop;
        vm.uploadPhoto           = uploadPhoto;
        vm.goUpdate              = goUpdate;
        vm.removeSeminar         = removeSeminar;
        vm.uploadHandlerCover    = uploadHandlerCover;
        vm.countResult           = 0;
        vm.registersInEventSelected = {name:'No', id:0};
        vm.registersInEventList = [{id:'all', name:'All'},{id:1, name:'Yes'},{id:0,name:'No'}];
        vm.platformThemes = [{id:'blue'},{id:'red'},{id:'orange'},{id:'yellow-blue'},{id:'yellow-green'},{id:'green'},{id:'green-blue'},{id:'blue-golden'},{id:'yellow-black'}]

        function activate() {
            if ($stateParams.hasOwnProperty('msg') && $stateParams.msg) {
                if ($stateParams.error) {
                    toastr.error(`${$stateParams.msg}`);
                } else {
                    toastr.success(`${$stateParams.msg}`);
                }
                
            }
            vm.selectExpo();
            vm.getSellers();
            vm.mountSeminar();
        }

        function removeSeminar(index){
            vm.delete_seminars.push({id: vm.seminars[index].id});
            vm.seminars.splice(index, 1);
        }

        function selectExpo () {
            ExpoService.getExposVirtualFair().then(function(response){
                    vm.expo = response.data;
            }).catch(function(err) {

            });
        }

        function getSellers() {
            SellerService.getAllVirtualFair().then(function(response){
                vm.seller = response.data;
                vm.seller.unshift({id: 498, name:"<span class='text-muted'>No Representative</span>"});
                vm.seller.unshift({id: -1,name:"All"});
            }).catch(function(err) {

            });
        }

        function mountSeminar(){
            if(seminars && seminars.length > 0){
                vm.virtual_fair = seminars[0].virtual_fair;
                vm.platform_theme = $filter('filter')(vm.platformThemes, {id: seminars[0].platform_theme})[0],
                vm.seminars = [];
                for(let i = 0; i < seminars.length; i++){                    
                    vm.seminars.push({
                        id: seminars[i].id,
                        order: seminars[i].order,
                        title: seminars[i].title,
                        institution: seminars[i].institution,
                        description: seminars[i].description,
                        show_date: seminars[i].show_date == 1,
                        logo_url: seminars[i].logo_url,
                        language: seminars[i].language,
                        presenters: seminars[i].presenters,
                        virtual_fair_id: seminars[i].virtual_fair,
                        platform_theme: vm.platform_theme.id,
                        update: true,
                        sessions: seminars[i].slots.map(elem => {
                            return {
                                button_label: elem.button_label,
                                end_datetime_utc: new Date(elem.end_datetime_utc),
                                expo_virtual_fair_seminar_id: elem.expo_virtual_fair_seminar_id,
                                id: elem.id,
                                order: elem.order,
                                start_datetime_utc: new Date(elem.start_datetime_utc),
                                url: elem.url,
                                cover: elem.cover
                            }
                        })
                    })
                }
            }
        }



        function addSession(index) {
            vm.seminars[index].sessions.push({
                button_label:   '',
                url:            '',
                order:          ''
            });
        }

        function addSeminar(){
            vm.seminars.push({
                title:          '',
                description:    '',
                institution:    '',
                show_date:      '',
                is_live:        '',
                order:          '',
                logo_url:       '',
                language:       '',
                presenters:     '',
                start_datetime: '',
                end_time:       '',
                virtual_fair_id: '',
                platform_theme: '',
                update: false,
                sessions:       [{
                    button_label: '',
                    url: '',
                    order: '',
                }],
                cover: '',
            });
        }

        function removeSession(session, index){
            if(typeof vm.seminars[index].sessions === 'object' && vm.seminars[index].sessions.length > 1) {                
                vm.seminars[index].sessions.splice(vm.seminars[index].sessions.indexOf(session), 1);
            }
        }

        function uploadPhoto(index) {
            vm.index = index;
            angular.element('#accountProfilePhoto').trigger('click');
        }

        function uploadHandler(e) {
            if (e.currentTarget.files.length) {
                var file = e.currentTarget.files[0];
                var reader = new FileReader();
                reader.onload = function (e) {
                    $scope.$apply(function() {
                        vm.imageCrop(e.target.result);
                    });
                };
                reader.readAsDataURL(file);
            }
            angular.element(e.target).val(null);
        }   

        function uploadHandlerCover(e, seminar) {

            if (e.currentTarget.files.length) {
                var file = e.currentTarget.files[0];
                var reader = new FileReader();
                reader.onload = function (e) {
                    $scope.$apply(function() {
                        seminar.cover = e.target.result
                        console.log(seminar)
                    });
                };
                reader.readAsDataURL(file);
            }
            angular.element(e.target).val(null);
        }   

        function imageCrop(uploaded) {
            $uibModal.open({
                size: 'sm',
                backdrop  : 'static',
                templateUrl: 'templates/physicalfairs/reports/pre-registrations/account/form/crop.modal.html',
                controller: ['$uibModalInstance', function ($uibModalInstance) {
                    var cropModal = this;
                    cropModal.cancel = $uibModalInstance.close;
                    cropModal.save = save;
                    cropModal.uploaded = uploaded;

                    function save() {
                        vm.seminars[vm.index].logo = cropModal.cropped;
                        cropModal.cancel();
                    }
                }],
                controllerAs: 'cropModal',
            });
        }

        function save(){
            if(seminars){
                update();
            }else{
                store();
            }
        }
        

        function store() {
            if(!$scope.reportFormStudent.$valid){
                return;
            }
            for(var i = 0; i < vm.seminars.length; i++){                
                vm.seminars[i].virtual_fair_id = vm.virtual_fair.id;
                vm.seminars[i].platform_theme = vm.platform_theme.id;
                if (vm.seminars[i].show_date == true) {
                    vm.seminars[i].sessions[0].start_datetime_utc = moment(vm.seminars[i].sessions[0].start_datetime_utc).format("YYYY-MM-DD HH:mm");
                    vm.seminars[i].sessions[0].end_datetime_utc = moment(vm.seminars[i].sessions[0].end_datetime_utc).format("YYYY-MM-DD HH:mm");
                }
            }
            VirtualFairService.storeSeminar(vm.seminars).then(function(response){
                alertify.success('Seminar successfull created!');
                vm.goUpdate(vm.seminars[0].virtual_fair_id);
            }).catch(function(err) {
            });
        }

        async function goToList () {
            return await $state.go('root.virtualfair.seminars');
        }

        async function goUpdate (id) {
            return await $state.go('root.virtualfair.seminars.form', {id: id});
        }

        function update() {
            if (vm.delete_seminars.length > 0) {
                for(var i = 0; i < vm.delete_seminars.length; i++){   
                    VirtualFairService.deleteSeminar(vm.delete_seminars[i].id).then(function(response){
                        alertify.success('Seminar successfull deleted!');
                    }).catch(function(err) {
                    });
                }
            }

            for(var i = 0; i < vm.seminars.length; i++){                
                vm.seminars[i].virtual_fair_id = typeof vm.virtual_fair == 'object' ? vm.virtual_fair.id : vm.seminars[i].virtual_fair.id;
                vm.seminars[i].platform_theme = typeof vm.platform_theme == 'object' ? vm.platform_theme.id : vm.seminars[i].platform_theme.id;
                if (vm.seminars[i].show_date == true) {
                    vm.seminars[i].sessions[0].start_datetime_utc = moment(vm.seminars[i].sessions[0].start_datetime_utc).format("YYYY-MM-DD HH:mm");
                    vm.seminars[i].sessions[0].end_datetime_utc = moment(vm.seminars[i].sessions[0].end_datetime_utc).format("YYYY-MM-DD HH:mm");
                }

                VirtualFairService.updateSeminar(vm.seminars[i], vm.seminars[i].id).then(function(response){
                    alertify.success('Seminar successfull updated!');
                }).catch(function(err) {
                });

                // if (vm.seminars[i].update) {
                //     VirtualFairService.updateSeminar(vm.seminars[i], vm.seminars[i].id).then(function(response){
                //         alertify.success('Seminar successfull updated!');
                //     }).catch(function(err) {
                //     });
                // } else {
                //     VirtualFairService.storeSeminar(vm.seminars[i]).then(function(response){
                //         alertify.success('Seminar successfull created!');                        
                //     }).catch(function(err) {
                //     });
                // }
            }
            vm.goToList();
           
        }  

       
        activate();
    }
})();
